import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { Button } from "@/components/ui/button";
import { useEffect, useState } from "react";

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <Button variant="ghost" size="icon" className="h-9 w-9">
        <Sun className="h-4 w-4" />
      </Button>
    );
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
      className="h-9 w-9 raven-glow transition-all duration-300"
    >
      {theme === "dark" ? (
        <Sun className="h-4 w-4 text-raven-electric transition-all" />
      ) : (
        <Moon className="h-4 w-4 text-raven-deep transition-all" />
      )}
      <span className="sr-only">Cambiar tema</span>
    </Button>
  );
}
